export default __webpack_public_path__ + "images/0x1a3496c18d558bd9c6c8f609e1b129f67ab08163.png";